"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var devices_directives_1 = require("./devices-directives");
exports.IsDesktop = devices_directives_1.IsDesktop;
exports.IsTablet = devices_directives_1.IsTablet;
exports.IsMobile = devices_directives_1.IsMobile;
exports.IsSmartTv = devices_directives_1.IsSmartTv;
exports.ShowItDevice = devices_directives_1.ShowItDevice;
exports.HideItDevice = devices_directives_1.HideItDevice;
exports.IsIphone = devices_directives_1.IsIphone;
exports.IsIpad = devices_directives_1.IsIpad;
exports.IsAndroidMobile = devices_directives_1.IsAndroidMobile;
exports.IsAndroidTablet = devices_directives_1.IsAndroidTablet;
exports.IsWindowsPhone = devices_directives_1.IsWindowsPhone;
exports.ShowItStandard = devices_directives_1.ShowItStandard;
exports.HideItStandard = devices_directives_1.HideItStandard;
exports.IsPortrait = devices_directives_1.IsPortrait;
exports.IsLandscape = devices_directives_1.IsLandscape;
exports.DeviceInfo = devices_directives_1.DeviceInfo;
exports.DeviceStandardInfo = devices_directives_1.DeviceStandardInfo;
exports.OrientationInfo = devices_directives_1.OrientationInfo;
exports.DEVICES_DIRECTIVES = [
    devices_directives_1.IsDesktop,
    devices_directives_1.IsTablet,
    devices_directives_1.IsMobile,
    devices_directives_1.IsSmartTv,
    devices_directives_1.ShowItDevice,
    devices_directives_1.HideItDevice,
    devices_directives_1.IsIphone,
    devices_directives_1.IsIpad,
    devices_directives_1.IsAndroidMobile,
    devices_directives_1.IsAndroidTablet,
    devices_directives_1.IsWindowsPhone,
    devices_directives_1.ShowItStandard,
    devices_directives_1.HideItStandard,
    devices_directives_1.IsPortrait,
    devices_directives_1.IsLandscape,
    devices_directives_1.DeviceInfo,
    devices_directives_1.DeviceStandardInfo,
    devices_directives_1.OrientationInfo
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2078029388/src/~/ng2-responsive/devices/index.js
// module id = UYth
// module chunks = 6